define('modules/strategy/supply/open/main',["T1Module"], function (T1Module) {
  "use strict";

  return new T1Module({
    name: "strategy/supply/open",
    viewCfgs: {
      bins: {},
      browse: {},
      panel: {},
      readOnly: {
        model: null
      }
    },
    defaultView: "panel"
  });
});
